export const SUB_ANCHOR_MAP = {
  CUSTOMER_INTEREST_ABANDONEDCARTS: {
    link: 'customerInterestAbandonedCart',
    linkTitle: '購物未結帳'
  },
  CUSTOMER_INTEREST_ARRIVALNOTICE: {
    link: 'customerInterestArrivalNotice',
    linkTitle: '貨到通知'
  },
  CUSTOMER_INTEREST_TRACKITEM: {
    link: 'customerInterestFavoriteProduct',
    linkTitle: '被收藏商品',
    highlight: false
  }
}

export const CUSTOMER_INTEREST_SUB_ITEMS = [
  SUB_ANCHOR_MAP.CUSTOMER_INTEREST_ABANDONEDCARTS,
  SUB_ANCHOR_MAP.CUSTOMER_INTEREST_ARRIVALNOTICE,
  SUB_ANCHOR_MAP.CUSTOMER_INTEREST_TRACKITEM
]
